import * as additionalActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    companies: {
        isFetching: false,
        listCompanies: null,
    },
    persons: {
        isFetching: false,
        listPersons: null,
    },
    regions: {
        isFetching: false,
        listRegions: null,
    },
    sources: {
        isFetching: false,
        listSources: null,
    },
    lawsSources: {
        isFetching: false,
        listSources: null,
    },
};

export const additionalReducer = (state = initialState, action) => {
    switch (action.type) {
        // COMPANIES
        case additionalActions.START_FETCH_COMPANIES:
            return {
                ...state,
                companies: {
                    ...state.companies,
                    isFetching: true,
                },
            };
        case additionalActions.GET_ALL_COMPANIES_LIST:
            return {
                ...state,
                companies: {
                    ...state.companies,
                    listCompanies: action.listCompanies,
                },
            };
        case additionalActions.FINISH_FETCH_COMPANIES:
            return {
                ...state,
                companies: {
                    ...state.companies,
                    isFetching: false,
                },
            };

        // PERSONS
        case additionalActions.START_FETCH_PERSONS:
            return {
                ...state,
                persons: {
                    ...state.persons,
                    isFetching: true,
                },
            };
        case additionalActions.GET_ALL_PERSONS_LIST:
            return {
                ...state,
                persons: {
                    ...state.persons,
                    listPersons: action.listPersons,
                },
            };
        case additionalActions.FINISH_FETCH_PERSONS:
            return {
                ...state,
                persons: {
                    ...state.persons,
                    isFetching: false,
                },
            };

        // REGIONS
        case additionalActions.START_FETCH_REGIONS:
            return {
                ...state,
                regions: {
                    ...state.regions,
                    isFetching: true,
                },
            };
        case additionalActions.GET_ALL_REGIONS_LIST:
            return {
                ...state,
                regions: {
                    ...state.regions,
                    listRegions: action.listRegions,
                },
            };
        case additionalActions.FINISH_FETCH_REGIONS:
            return {
                ...state,
                regions: {
                    ...state.regions,
                    isFetching: false,
                },
            };

        // SOURCES
        case additionalActions.START_FETCH_SOURCES:
            return {
                ...state,
                sources: {
                    ...state.sources,
                    isFetching: true,
                },
            };
        case additionalActions.GET_ALL_SOURCES_LIST:
            return {
                ...state,
                sources: {
                    ...state.sources,
                    listSources: action.listSources,
                },
            };
        case additionalActions.FINISH_FETCH_SOURCES:
            return {
                ...state,
                sources: {
                    ...state.sources,
                    isFetching: false,
                },
            };

        // LAWS SOURCES
        case additionalActions.START_FETCH_LAWS_SOURCES:
            return {
                ...state,
                lawsSources: {
                    ...state.lawsSources,
                    isFetching: true,
                },
            };
        case additionalActions.GET_ALL_LAWS_SOURCES_LIST:
            return {
                ...state,
                lawsSources: {
                    ...state.lawsSources,
                    listSources: action.listSources,
                },
            };
        case additionalActions.FINISH_FETCH_LAWS_SOURCES:
            return {
                ...state,
                lawsSources: {
                    ...state.lawsSources,
                    isFetching: false,
                },
            };

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/additional/reducer.js